import moment from 'moment';
import { Component, OnInit, Input } from '@angular/core';
import { FullFacModel } from '../../../../core/models/edit-fac-modal.model';
import { FormGroup, ControlContainer } from '@angular/forms';
import { EditFacModalService } from '../service/edit-fac-modal.service';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { ZipFlagListOptions } from '../../zip-code-flag-input/zip-code-flag-input.model';

@Component({
  selector: 'app-modal-more-details',
  templateUrl: './modal-more-details.component.html',
  styleUrls: ['./modal-more-details.component.scss']
})

export class ModalMoreDetailsComponent implements OnInit {
  @Input() facItem: FullFacModel;
  public moreInfoForm: FormGroup;
  public saved = false;
  public currentFlag = ZipFlagListOptions[0];

  constructor(
    private controlContainer: ControlContainer,
    private facModalService: EditFacModalService,
    private snackbarService: SnackbarService,
    private checkStatusService: CheckTaskStatusService,
    private translate: TranslateService,
    private environmentService: EnvironmentService
  ) { }

  ngOnInit() {
    this.moreInfoForm = this.controlContainer.control as FormGroup;
  }

  formatRG(ev: KeyboardEvent) {
    const rgRegex = new RegExp('\[a-zA-Z0-9.-]');
    if (!rgRegex.test(ev.key)) {
      ev.preventDefault();
    }
  }

  getAddress() {
    if (this.moreInfoForm.get('address').get('zip_code').value.length === 0) {
      this.moreInfoForm.get('address').get('city').patchValue('');
      this.moreInfoForm.get('address').get('state').patchValue('');
      this.moreInfoForm.get('address').get('street').patchValue('');
      this.moreInfoForm.get('address').get('neighborhood').patchValue('');
      this.moreInfoForm.get('address').get('number').patchValue('');
      this.moreInfoForm.get('address').get('complement').patchValue('');
    }

    if (this.moreInfoForm.get('address').get('zip_code').value.length === 8) {
      this.facModalService.getFacAddress(this.currentFlag.country,
        this.moreInfoForm.get('address').get('zip_code').value).subscribe(resp => {
          this.moreInfoForm.get('address').get('city').patchValue(resp.city);
          this.moreInfoForm.get('address').get('state').patchValue(resp.state);
          this.moreInfoForm.get('address').get('street').patchValue(resp.street);
          this.moreInfoForm.get('address').get('neighborhood').patchValue(resp.neighborhood);
          this.moreInfoForm.get('address').get('number').patchValue('');
          this.moreInfoForm.get('address').get('complement').patchValue('');
      }, err => {
        this.snackbarService.show(err.error.messages[0].message, 'error');
      });
    }
  }

  saveMoreInfo() {
    this.saved = true;
    for (const form in (this.moreInfoForm.get('address') as FormGroup).controls) {
      if ((this.moreInfoForm.get('address') as FormGroup).get(form)) {
        (this.moreInfoForm.get('address') as FormGroup).get(form).updateValueAndValidity();
      }
    }

    if (this.moreInfoForm.invalid) {
      this.snackbarService.show('Verifique as informações incorretas', 'warning');
      return;
    }

    const requestBody = this.moreInfoForm.getRawValue();

    if (this.moreInfoForm.get('person').get('birth_date').value) {
      const formatedDate = moment(
        new Date(this.moreInfoForm.get('person').get('birth_date').value).setHours(0, 0, 0, 0)
      ).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
      requestBody.person.birth_date = formatedDate;
    }

    for (const key in requestBody.address) {
      if (!requestBody.address[key]) {
        requestBody.address[key] = null;
      }
    }

    for (const key in requestBody.person) {
      if (!requestBody.person[key]) {
        requestBody.person[key] = null;
      }
    }

    this.facModalService.setLoader(true);
    this.facModalService.patchFacById(this.facItem.id, requestBody).subscribe(resp => {
      this.checkStatusService.checkTaskStatus(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(task => {
      this.snackbarService.show('As alterações foram salvas.', 'success');
      this.facModalService.setLoader(false);
      },
      err => {
        this.facModalService.setLoader(false);
        this.snackbarService.show(err.error.messages[0].message, 'error');
      });
    },
    err => {
      this.facModalService.setLoader(false);
      this.snackbarService.show(err.error.messages[0].message, 'error');
    });
  }
}
